import styles from './Name.module.css';
import React from 'react';

export const Name = React.memo(({ message }) => {
  return <div className={styles.name}>{message.author}</div>;
});
